import React from 'react';
import {KTMScreen,ActionEvent,RenderEvent,renderScreen, Line} from 'ktm-ui';
import {KTMApi} from 'api/KTMApi';
import {Layout,RecordHeader,TabSet,Tab,Display,Button,Column,Panel,EmptyState} from 'ktm-ui';
import BenefitsScreen from './Benefits';
import EditScreen from './Edit';
import axios from "axios";

interface IdsBenCat {
  Id: string;
  Name: string;
  Description: string;
  Policy_Id: string;
}

interface IdsPolicy {
  Id: string;
  CurrentBenYear_Id: string;
  NextBenYear_Id: string;
}

interface IdsBenefits {
  BenefitLimit_Id: string;
  Policy_Id: string;
  BenefitCategory_Id: string;
  BenefitYear_Id: string;
}

export default KTMScreen(
  { name:"planadmin.bencat.record"}, 
  class extends React.Component<{ bencat_id: string }, any> {
    data: {
      dsBenCat: IdsBenCat;
      dsPolicy: IdsPolicy;
      dsBenefits: IdsBenefits;
    };

    constructor(props) {
      super(props);
      this.state = {
          employeesCount: 0,
      };
    }

    render() {
      return renderScreen(this);
    }

    async start({ screen }: ActionEvent) {
      screen.defaultRecord = "@dsBenCat";
      await KTMApi.start(screen, {
        "@bencat_id": this.props.bencat_id,
      });
      screen.title = this.data.dsBenCat.Name;
      await this.getNumberofEmployees();
    }

    main({ field, draw, action }: RenderEvent) {
      return (
        <Layout>
          {draw(this.header)}
          {draw(this.tabs)}
        </Layout>
      );
    }

    header({ field, draw, action }: RenderEvent) {
      return (
        <RecordHeader
          entityLabel="Benefit Category"
          label={this.data.dsBenCat.Name}
        >
          <Line>
            <Display field={field("Description")} />
            <div className="RT-Static-Field">
              <label className="RT-Static-Field__label">
                Enrolled Employees 
              </label>
              <div className="RT-Static-Field__content">
                {this.state.employeesCount}
              </div>
            </div>
          </Line>
        </RecordHeader>
      );
    }

    tabs({ field, draw, action }: RenderEvent) {
      return (
        <TabSet>
          <Tab label="Benefits" template={this.benefits_tab} />
        </TabSet>
      );
    }

    benefits_tab({field,draw,action}:RenderEvent){
        return (
            <BenefitsScreen 
                bencat_id={this.data.dsBenCat.Id} 
                policy_id={this.data.dsBenCat.Policy_Id} 
                benyear_id={this.data.dsPolicy.CurrentBenYear_Id}
            />
        );
    }

    next_year_tab({ field, draw, action }: RenderEvent) {
      return (
        <Panel>
          <Column>{draw(this.next_year_empty)}</Column>
        </Panel>
      );
    }

    next_year_empty({ field, draw, action }: RenderEvent) {
      return (
        <EmptyState
          label="Next year not available for edit yet"
          icon="edit"
        ></EmptyState>
      );
    }

    async edit({ screen }: ActionEvent) {
      await screen.openDialog(
        <EditScreen bencat_id={this.data.dsBenCat.Id}/>,
        { onRecordChanged: this.refresh_data }
      );
    }

    async refresh_data({ screen }: ActionEvent) {
      await screen.restart();
    }

    getNumberofEmployees = async () => {
      try {
          axios.get("/api/BenefitCategories/checkeligibilityofeditingbencat", {
              params: { 
                  benefitCategoryId: this.data.dsBenCat.Id 
              }
          }).then((response) => {
              if (response.data.success) {
                  this.setState({
                    employeesCount: response.data.employeesCount,
                    employeeHasClaims: response.data.employeeHasClaims
                  });
              }
          });
      } catch (error) {
          console.error(error);
      }
    }
  }
);
